<template>
  <div id="app">
    <!-- Global Error Boundary wraps the entire application -->
    <error-boundary-wrapper>
      <router-view />
    </error-boundary-wrapper>
    
    <!-- Session Manager (handles both warning toast and expired modal) -->
    <session-manager />
  </div>
</template>

<script>
import appConfig from "@/app.config";
import resetSessionTimer from './components/session/session.js';
import { createErrorBoundary } from '@/utils/errorHandler';
import ErrorBoundary from '@/components/errors/ErrorBoundary.vue';
import SessionManager from '@/components/session/SessionManager.vue';

// Create the error boundary wrapper component
const ErrorBoundaryWrapper = createErrorBoundary('ErrorBoundary');

export default {
  name: "app",
  components: {
    ErrorBoundaryWrapper,
    ErrorBoundary,
    SessionManager
  },
  data() {
    return {
      // Data properties can be removed since SessionManager handles session state
    };
  },
  created() {
    resetSessionTimer();
    
    // Set up global error monitoring
    this.setupErrorMonitoring();
    
    // Listen for session expiry events
    this.setupSessionMonitoring();
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  },
  methods: {
    setupErrorMonitoring() {
      // Monitor for any unhandled errors that might slip through
      window.addEventListener('error', (event) => {
        console.error('Unhandled error caught at App level:', event.error);
      });
      
      // Monitor for unhandled promise rejections
      window.addEventListener('unhandledrejection', (event) => {
        console.error('Unhandled promise rejection caught at App level:', event.reason);
      });
    },
    
    setupSessionMonitoring() {
      // Session monitoring is now handled by SessionManager component
      // This method can be simplified or removed
      console.log('Session monitoring setup - handled by SessionManager');
    }
  }
};
</script>